var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSystemMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9.314 6.286H19.6M9.314 18.172h7.143m-7.143-5.943H19.6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.027 7.771c.714 0 1.429-.742 1.429-1.485S5.74 4.8 5.027 4.8 3.6 5.543 3.6 6.286 4.313 7.77 5.027 7.77m0 5.943c.714 0 1.429-.742 1.429-1.485s-.715-1.486-1.429-1.486-1.427.743-1.427 1.486.713 1.485 1.427 1.485m0 5.943c.714 0 1.429-.743 1.429-1.485s-.715-1.486-1.429-1.486-1.427.743-1.427 1.486c0 .742.713 1.485 1.427 1.485",
  clipRule: "evenodd"
})));
export default SvgSystemMenu;